(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["review-highlight__sec"] && !Shopify.designMode) return;
  try {
    
    var swiper = new Swiper('.clothes_multicolumn2 .testimonials-swiper', {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 29,
    pagination: {
      el: '.clothes_multicolumn2 .swiper-pagination',
      clickable: true,
    },
    breakpoints: {
        768: {
        slidesPerView: 3,
        }
    }
    });

  } catch(e) { console.error(e); }
})();
})();
